<template>
  <div class="totals-statistics mt-1 mb-2">
    <div class="d-flex align-items-center col">
      <span class="statistics-heading">
        Statistics for {{ meta.total }} jobs
      </span>
    </div>
    <div class="d-flex align-items-center col justify-content-start">
      <span class="statistics-heading total-hours">
        {{ sums.total_hours }}
      </span>
    </div>
    <div class="d-flex align-items-center col justify-content-center">
      <span class="statistics-heading total-amount">
        ${{ sums.total_amount }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    meta: {
      type: Object,
      default: () => {},
    },
    sums: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
.totals-statistics {
  display: flex;
  background: #3f4247;
  box-shadow: 0 2px 0 rgba(33, 37, 41, 0.0263604);
  border-radius: 2px;
  justify-content: space-between;
  padding: 7px;
}
.statistics-heading {
  color: white;
  font-weight: 500;
  font-size: 12px;
}
.total-amount {
  font-size: 17px;
  width: 28%;
}
.total-hours {
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/MoverTotalsStatistics.vue